import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { ClientContractList } from '~/features/ClientContractList';
import styles from './styles.module.scss';

/**
 * 企業契約期間一覧 Screen
 *
 * - サイドバー導線のためパスパラメータなし（clientId 不要）
 * - PageHeader は API 発火しないため Screen で直接表示（Feature 化不要）
 */
export const Screen: React.FC = () => (
  <>
    <PageHeader variant='title' title='企業契約期間' />
    <main className={styles.body}>
      <Suspense fallback={<Loader />}>
        <ClientContractList />
      </Suspense>
    </main>
  </>
);
